var notificationCenterI18n = {
  actionButton: 'Action button',
  noNotifications: 'There are no notifications.',
  title: 'Notifications'
};
export default notificationCenterI18n;